import React from 'react'
import { Tag } from "antd" 
import { ClockCircleFilled,CheckCircleFilled,CloseCircleFilled } from "@ant-design/icons"


function TagJoStatus({result = ""}) {
  let elementToRender;

  switch (result?.toLowerCase()) {
    case 'ผลิตเสร็จแล้ว':
      elementToRender = <Tag icon={<CheckCircleFilled />} color="#87d068"  > ผลิตเสร็จแล้ว </Tag>;
      break;
      case 'ส่งออกแล้ว':
      elementToRender = <Tag icon={<CheckCircleFilled />} color="#87d068"> ส่งออกแล้ว </Tag>;
      break;
    case 'รอดำเนินการ':
      elementToRender = <Tag icon={<ClockCircleFilled />} color="#ababab" > รอดำเนินการ </Tag>;
      break;
    case 'ยกเลิก':
      elementToRender = <Tag icon={<CloseCircleFilled />} color="#f5222d" > ยกเลิก </Tag>;
      break;
    default:
      /* สถานะอื่นที่ยังไม่ได้กำหนดสี — แสดงข้อความเดิมไว้ ดีกว่าขึ้น Not found */
      elementToRender = result
        ? <Tag className='flex gap-2 justify-center items-center'>{result}</Tag>
        : <Tag className='flex gap-2 justify-center items-center'>-</Tag>;
  }
  return <>{elementToRender}</>
}

export default TagJoStatus